
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/black",
      function () {
        return require("private-next-pages/black/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/black"])
      });
    }
  